<div class="info__item__text">
  <p>
    These Terms of Service (the “Terms”) constitute a legal agreement between
    you and ESi holding Ltd trading as ESi.com of Tallinn Estonia Registration
    number [TBA], <a href="/" target="_blank">www.esi.one</a> (hereinafter "ESi Holdings"
    or "we") governing the use of our services.&nbsp;These Terms, and other documents
    referred to in these Terms constitute a legal contract between you and us and
    set out both your and our rights and obligations under the Agreement and important
    information regarding the Services that we will provide to you. For your own
    protection you should read them carefully before accepting them. If you do not
    understand anything, contact us to ask for further information.
  </p>
  <p>
    These Terms are provided in English, which will be the language of all
    communications between you and us.&nbsp;
  </p>
  <div class="legal__row">
    <div class="legal__row__head"><strong>The Services</strong></div>
    <p>
      ESI is authorised and regulated by the Estonian Financial Supervisory
      Authority with registration number [TBA].&nbsp;
    </p>
    <p>
      We are a Discretionary Investment Management firm able to act on your
      behalf in creating and managing a range of investment Plans As set out on
      our website and chosen by you when opening an account and subscribing to a
      Plan or multiple Plans (for ease of reading, we refer to the singular
      “Plan”).
    </p>
    <p>In order to subscribe for the Services, you must:</p>
    <ul role="list">
      <li>accept the Terms applicable to ESI and the Service;</li>
      <li>satisfy our identity checks; and</li>
      <li>satisfy our suitability criteria.</li>
    </ul>
    <p>
      Our Services enable you to select a Plan (“Green Safe”, “Green Adventure”,
      “Green Founder” or all) and open an Account in order to invest on an
      execution only basis as further described on the website.
    </p>
    <p>
      We do not provide ﬁnancial, investment or tax advice as part of the
      Services. Neither we nor our Associates give, nor is anything on the
      website or any linked website to be construed as personal investment
      recommendations, ﬁnancial, or tax advice of any kind. you are responsible
      for selecting the Plan and any investments.
    </p>
    <p>
      Since we do not provide financial, investment or tax advice as part of the
      services, we are not required to assess the suitability or appropriateness
      for you of:
    </p>
    <ul role="list">
      <li>
        the investments that you choose, that we may hold for you in your
        Account;
      </li>
      <li>the Plan that you choose; or</li>
      <li>he other Services we provide to you.</li>
    </ul>
    <p>
      Suitability to invest is based on your financial situation and ability to
      bear any losses, your objectives and attitude to risk and whether you have
      the knowledge and experience to understand the risks involved.
    </p>
    <p>
      The decision whether to allow you to open an Account is entirely ours and
      we may decide for any reason, or no reason, not to authorise you. We may,
      at our discretion, permit you to answer the questions again at a future
      date, but we are under no obligation to do so.
    </p>
    <p>
      If you are in any doubt about the suitability or appropriateness of any
      particular Plan, investment or any part of the Service, we recommend that
      you speak with a financial adviser.
    </p>
    <p>
      We will provide the Services with reasonable skill and care but, because
      we do not give advice, we cannot guarantee that they will meet your
      particular needs.
    </p>
    <p>
      The impact of events and circumstances outside our control, including but
      not limited to the ongoing movements in the markets and fluctuations in
      the value of investments, will not automatically be deemed to be a breach
      of any Plan’s investment objectives or risk profile. Our Plans are managed
      on a fully discretionary basis to match defined risk profiles. This
      service enables us to make investment decisions on your behalf without
      needing to obtain your approval for those transactions. You will see on
      your periodic statements the changes that are made.
    </p>
    <p>
      You are required to accept the risk profile and characteristics of the
      Plan selected. Where additional investment is made into a Plan it will be
      invested and managed in accordance with the Plan selected.
    </p>
    <p>
      We will not accept specific instructions relating to individual
      investments within the Plan.
    </p>
    <p>
      When funds have arrived, they will typically be invested within five (5)
      working days. There may be occasions when it will take longer than this.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Your Account</strong></div>
    <p>
      By registering for an Account, which involves providing us with certain
      mandatory and voluntary information as required for a successful
      registration and using our website, you agree and acknowledge that:&nbsp;
    </p>
    <ul role="list">
      <li>
        you are at least 18 years old and have the full legal capacity to accept
        these Terms;
      </li>
      <li>
        you have read the terms set out in these Terms and agree to be bound by
        and comply with them; and
      </li>
      <li>you shall ensure that you abide by these Terms. &nbsp;</li>
    </ul>
    <p>
      We are currently unable to offer Services to US passport holders or
      nationals of any country listed in the United States Department of
      Treasury’s Office of Foreign Assets Control website at
      http://www.treas.gov/ofac.&nbsp;
    </p>
    <p>
      You are responsible for maintaining the confidentiality of your Account
      and you are responsible for all activities that occur under your Account.
      You agree that all actions carried out by any person through your Account
      shall be deemed to be an act carried out by you, and you shall ensure that
      all persons who have access to and use your Account are authorised to do
      so. We are not responsible for any loss, damage or liabilities arising as
      a result of or in connection with the wrongful, fraudulent or illegal use
      of your Account.
    </p>
    <p>
      You must notify us immediately if you learn or suspect that the security
      of your username or password may have been breached. If we receive such a
      notification from you or determine ourselves that the security of your
      username or password may have been breached, you will not be able to
      access the website until measures have been taken to verify your identity.
    </p>
    <p>
      We reserve the right to, without any notice, explanation, or liability and
      in our sole discretion, refuse to allow you or suspend your access to or
      your Account at any time.&nbsp;
    </p>
    <p>
      You agree that access to or operation of any of the foregoing may from
      time to time be interrupted or encounter technical difficulties.
    </p>
    <p>
      Your online Account will allow you to view details of your Plan, for
      example, where your money is invested and the values. Your online Account
      also allows you to view Account literature and any other Important
      document that is relevant to your Plan.&nbsp;
    </p>
    <p>
      Any Instructions to change personal details or contact details on your
      Account may be made by you. It is important that you maintain the email
      address we have for you to ensure that any important communications or
      alerts are received. You should also make sure that your email settings
      are set up to receive emails from us.
    </p>
    <p>
      If you open multiple Plans, you will automatically be able to view all the
      details and documents for the new Plan under the same Account.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Closing Your Account</strong></div>
    <p>
      In addition to your cancellation rights, we are be entitled to close one
      or more of your Plans or Account for the following reasons:
    </p>
    <ul role="list">
      <li>
        if you have not given us any documents, we need to meet our regulatory
        or legal responsibilities;
      </li>
      <li>
        if you have failed to provide us with satisfactory evidence or
        documentation for us to complete our anti money laundering verification
        process;
      </li>
      <li>
        if we believe, that any information or declaration you have given to us
        when opening an Account or subsequently, is untrue, misleading, or
        incomplete in any material way, or if you fail to inform us of any
        information you later become aware of which makes any previous
        information untrue, misleading or incomplete;
      </li>
      <li>if under the terms of a court order; or</li>
      <li>
        if you have done or failed to do something which means we are unable to
        comply with our legal and/or regulatory obligations.
      </li>
    </ul>
    <p>
      We will let you know in writing the date on which we will be closing your
      Plan or Account.
    </p>
    <p>
      We will not be legally responsible for any remuneration, costs, charges,
      fees, expenses, taxes or other amounts which become payable by closing
      your Plans or Account.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Subscription</strong></div>
    <p>
      You become a subscriber to your chosen Plan by completing the registration
      of an Account.&nbsp;
    </p>
    <p>
      Participation in your chosen Plan requires recurring payments and fees.
      These Fees will be notified to you through our website.&nbsp;
    </p>
    <p>
      If you subscribe to a Plan, the period for your Account shall be renewed
      automatically at the expiry of each subscription period, until terminated
      successfully through our website. By subscribing to a Plan, you authorise
      us or our related corporations to automatically charge the Fees applicable
      to your Plan:&nbsp;
    </p>
    <p>
      upon the commencement of your first subscription period or at a date
      otherwise indicated by us; and&nbsp;
    </p>
    <p>
      on the renewal date of the subscription period thereafter, without any
      further action by you.&nbsp;
    </p>
    <p>
      Any Fees due in relation to your Account must be paid by their due date
      for payment, as notified to you through our website or otherwise. Failure
      to make timely payment of the Fees may result in the suspension or
      termination of your access to your Plan or any of the Services.&nbsp;
    </p>
    <p>You shall be responsible for any applicable taxes under these Terms.</p>
    <p>
      All payments shall be made by using the payment methods specified by us
      from time to time. You acknowledge and agree that you are subject to the
      applicable user agreement of any third-party payment methods. We shall not
      be liable for any failure, disruption or error in connection with your
      chosen payment method. We reserve the right at any time to modify or
      discontinue, temporarily or permanently, any payment method without notice
      to you or giving any reason.
    </p>
    <p>
      We must receive payment in full no later than the day on which such
      payment is required to be paid in immediately available and freely
      transferable funds, without any restriction, condition, withholding,
      deduction, set-off or counterclaim whatsoever.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Our Fees</strong></div>
    <p>
      We will deduct our fee directly from your Plan as follows and will be
      clearly marked on your statements:
    </p>
    <ul role="list">
      <li>
        Contribution Fee: 0.5% of contribution will be charged on the day of
        transaction.
      </li>
      <li>
        Withdraw for contribution over 12-month-old: 0.5% of total withdraw
      </li>
      <li>
        Withdraw of contribution less than 12 month: 4.9% of the withdraw that
        has partially or totally less than 12 months been contributed.
      </li>
    </ul>
    <p>For clarity the following example may be used:</p>
    <p>
      If you are to withdraw 1000 Euro and 890 Euro have been in your wallet for
      more than 12 month and 110 Euro have been your wallet for less than 12
      months. You would be charge 0.5% on the 890 Euro and 4.9% on the 110
      Euro.&nbsp;
    </p>
    <p>
      <span class="bold-text">Please note: </span>the forgoing is for
      illustrative purposes only. For further information on our Fees please
      refer to our website.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Legal Compliance&nbsp;</strong></div>
    <p>
      We have certain responsibilities under the Applicable Laws to verify the
      identity of, and run anti- money laundering checks on, our customers prior
      to their investing. In order to fulfil these responsibilities, we will use
      third-party identification checking services to confirm your identity when
      you first seek to invest, and we will carry out regular monitoring checks
      while you remain a customer. We may also use credit reference agencies for
      this purpose. This will place a search footprint on your electronic file
      and your personal details may be accessed by third parties for the
      specific purpose of anti-money laundering, credit assessment, identity
      verification, debt collection, asset reunification, tracing and fraud
      prevention.
    </p>
    <p>
      We will not be liable for any losses, damages or costs arising from our
      conduct of the checks, your inability to make investments while the checks
      are pending or as a result of the unsatisfactory completion of the checks.
    </p>
    <p>
      We are legally obliged to keep your affairs confidential. However, we may
      be required by Applicable Law to make a disclosure to the Estonian
      Financial Supervisory Authority or other governmental institution where we
      know or suspect that a transaction may involve money laundering or
      terrorist financing. If we make a disclosure in relation to this matter,
      we may not be able to tell you that a disclosure has been made. We may
      have to stop providing Services to you for a period of time and may not be
      able to tell you why. We shall not be liable in any way whatsoever for any
      loss or damage (including any costs, expenses or liabilities) of any kind
      incurred by you as a result of having to make such a disclosure or having
      to stop providing Services to you for such period of time.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Notices and Reports</strong></div>
    <p>
      We will send all notices, information and other correspondence to you to
      the email address you have provided us with when you set up your account.
      You agree as an ongoing obligation to provide us with an up-to-date email
      address and to inform us as soon as reasonably practicable if this should
      change. We are entitled to rely on the last email address you have
      provided, and an email sent to that email address shall be sufficient.
    </p>
    <p>
      We cannot guarantee that general emails will be successfully delivered, or
      that they will be secure and virus free. We will not be liable for any
      loss, damage, expense, harm or inconvenience caused as a result of an
      email being lost, delayed, intercepted, corrupted or otherwise altered, or
      for failing to be delivered for any reason beyond our reasonable control.
    </p>
    <p>
      If we choose to correspond by post, communications will be sent to the
      address you provided when you set up your Account.&nbsp;
    </p>
    <p>
      We will not be liable for any error of transmission or misunderstanding,
      or for the fraud of any other party (except in the case of our negligence,
      wilful default or fraud).
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Your Obligations</strong></div>
    <p>
      You will be legally bound by the Terms so it is important on entering it,
      and on a periodic basis to confirm, that you have and will maintain full
      legal capacity and all necessary authority, permissions and powers, and
      have taken all necessary action to enable you to enter into these Terms
      lawfully and to grant us, rights and powers referred to in these Terms.
    </p>
    <p>You agree to:</p>
    <ul role="list">
      <li>co-operate with us in all matters relating to the Services;</li>
      <li>
        provide us with such information and materials as we may reasonably
        require in order to supply the Services and ensure that such information
        is true and accurate;
      </li>
      <li>
        regularly log on to your Account to review your Investments as well as
        any communication or documentation that may be added from time to time;
        and
      </li>
      <li>
        notify us promptly of any changes to your circumstances or information
        you provided.
      </li>
    </ul>
  </div>
  <p>
    In accepting these terms, you confirm there is no action, suit or
    proceeding, or pending or threatened action, suit or proceeding, before any
    court, tribunal, governmental body, agency or official, or any arbitrator
    that purports to affect or is likely to affect, the legality, validity or
    enforceability against you of these Terms or ability to perform your
    obligations under these Terms.
  </p>
  <p>
    You are wholly responsible for the accuracy of any information that you
    provide to us and we shall not be liable in any way whatsoever should
    incorrect data received from you result in financial loss or damage
    (including any costs, expenses or liabilities) of any kind. You will notify
    us immediately if you discover that any information, we hold for you is
    obsolete, incorrect, misleading, inconsistent and/or irrelevant in any way.
  </p>
  <p>
    If our performance of any of its obligations under this Agreement is
    prevented or delayed by any act or omission by you or your failure to
    perform any relevant obligation under these Terms, we have without limiting
    its other rights or remedies the right to suspend performance of the
    Services until you remedy the Default.
  </p>
  <p>
    In the event of a Default, we will not be liable for any costs or losses
    sustained or incurred by you arising directly or indirectly from our failure
    or delay to perform any of our obligations due to your default.
  </p>
  <p>
    You will indemnify us against any liability, cost, expense, loss or any
    damage incurred by us (including but not limited to professional advisors'
    fees) arising from your breach of these Terms, negligence, wilful default or
    fraud or fraudulent misrepresentation.
  </p>
  <p>
    You may use our Services only for lawful purposes. You may not use our
    Services:
  </p>
  <ul role="list">
    <li>
      in any way that breaches any applicable local or international laws or
      regulations;
    </li>
    <li>
      in any way that is unlawful or fraudulent, or has any unlawful or
      fraudulent purpose or effect;
    </li>
    <li>
      to send, knowingly receive, upload, download, use or re-use any material
      which does not comply with our content standards as set out in our
      prevailing terms and conditions as amended from time to time; and
    </li>
    <li>
      to knowingly transmit any data, send or upload any material that contains
      viruses, Trojan horses, worms, time-bombs, keystroke loggers, spyware,
      adware or any other harmful programs or similar computer code designed to
      adversely affect the operation of any computer software or hardware.
    </li>
  </ul>
  <p>You also agree:</p>
  <ul role="list">
    <li>
      not to reproduce, duplicate, copy or re-sell any part of our Services in
      contravention of the provisions of our Terms; and
    </li>
    <li>not to access without authority, interfere with, damage or disrupt:</li>
    <li>any part of our Services;</li>
    <li>any equipment or network on which our Services are stored;&nbsp;</li>
    <li>any software used in the provision of our Services; or&nbsp;</li>
    <li>
      any equipment or network or software owned or used by any third party.
    </li>
  </ul>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Complaints</strong></div>
    <p>
      If you wish to make a complaint in relation to our services, please
      contact us. If we are unable to resolve your complaint to your
      satisfaction, you can write directly to the Estonian Financial Supervisory
      Authority.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Risk Warning</strong></div>
    <p>
      For your information we have provided a summary of the main risks that are
      associated with investing and opening an Account with us. This list is not
      comprehensive but should act as a guide for you to better understand the
      risks involved.
    </p>
    <p>
      We do not provide investment advice and shall not at any time be under any
      duty to provide any such advice and shall not be regarded as having done
      so.
    </p>
    <p>
      You are solely responsible for seeking your own advice and making your own
      independent assessment of the risks of transactions. We have not
      undertaken any assessment whatsoever of your personal circumstances and
      will not make any personal recommendation to you.
    </p>
    <p>
      If you are unsure on any matter, you should consider taking independent
      professional advice, such as financial advice, legal and tax advice in
      relation to your individual circumstances and requirements.
    </p>
    <p>
      The value of your investment is not guaranteed, and prices may go down as
      well as up. You may get back less than the amount you originally invested.
    </p>
    <p>
      External factors may cause the value of your investments to fall. You are
      not certain to make a profit. You may make a loss. You may lose your
      entire investment.
    </p>
    <p>
      If the value of your investment changes by less than the rate of
      inflation, it will have less buying power in the future.
    </p>
    <p>
      We provide discretionary investment management, where your investments are
      managed by us. This means that we have discretion over both asset
      allocation and security selection in relation to the assets held for you.
      This means that your Plan and its performance will be specific to you,
      even when compared to a Plan with a broadly similar mandate.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Conflicts of Interest</strong></div>
    <p>
      We have a Compliance department which is responsible for ensuring that
      control structures and procedures are adequate to ensure compliance with
      all relevant laws, regulations, codes and practices relating to its
      business activities.
    </p>
    <p>Our Compliance department is also responsible for:</p>
    <ul role="list">
      <li>
        Maintaining and operating effective organisational and administrative
        arrangements with a view to taking all reasonable steps to prevent
        conflicts of interest from giving rise to a material risk of damage to
        the interests of clients; and
      </li>
      <li>
        Establishing, implementing and maintaining an effective written
        conflicts of interest policy which takes into account any circumstances,
        of which the firm is, or should be aware of, that give rise to a
        conflict of interest arising as a result of the structure and business
        activities of the firm.
      </li>
    </ul>
    <p>
      The types of conflicts of interest which may arise include, but are not
      limited to the following:
    </p>
    <ul role="list">
      <li>Acting for more than one customer in a transaction;</li>
      <li>
        Receiving gifts or entertainment which could conflict with our duties to
        you;
      </li>
      <li>
        Employees pursuing activities or personal relationships potentially
        detrimental to you;
      </li>
      <li>
        Holding information on other customers that would affect you or them if
        it was disclosed;
      </li>
      <li>Personal account holdings in investments being recommended by us;</li>
      <li>
        If an ESI employee has interest in the outcome of a service provided to
        the client or of a transaction carried out on behalf of the client,
        which is distinct from the client’s interest in that outcome;
      </li>
      <li>
        If an ESI employee has a financial or other incentive to favour the
        interest of another client or group of clients over the interests of the
        client.
      </li>
    </ul>
    <p>
      We are committed to operating in the best interests of its clients and
      managing conflicts of interest fairly. Where ESI has a material interest
      or a conflict of interest, it may not knowingly deal or advise unless it
      has taken reasonable steps to ensure fair treatment for its clients.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Liability</strong></div>
    <p>
      No provision of the Agreement will be deemed to restrict, qualify or
      exclude any duty owed to you under applicable law or that applicable law
      does not allow to be excluded or restricted. Except and to the extent of
      any duties that we owe you in accordance with any statutory rights that we
      cannot lawfully exclude or restrict any liability therefor, we do not owe
      you any further duties except as expressly set out in this Agreement.
    </p>
    <p>
      We will not be liable to you for any loss, damages or costs suffered or
      incurred by you except and only to the extent that such loss arises
      directly from our negligence, wilful default, or fraud. We will not be
      liable to you for any losses, damages or costs suffered or incurred by
      you:
    </p>
    <ul role="list">
      <li>
        which could not have been reasonably anticipated by us when you gave us
        an instruction;
      </li>
      <li>
        in relation to any loss of business, loss of goodwill, loss of
        opportunity or loss of profit; or
      </li>
      <li>which are indirect or consequential.</li>
    </ul>
    <p>
      Nothing in these Terms require you to compensate us to any extent
      prohibited by applicable law.
    </p>
    <p>
      We will not be liable for any loss or damage of any kind that is
      attributable to:
    </p>
    <ul role="list">
      <li>
        our failure to take any action which, in our opinion, might breach an a
        applicable law, or any action taken in order to comply with Applicable
        Law or the requirements of any market;
      </li>
      <li>
        any fall in the value of investments (including, without limitation,
        those which may occur due to delays during the process of verifying your
        identity in compliance with money laundering regulations);
      </li>
      <li>
        any reasonable refusal or failure to accept and / or execute any
        investment on your behalf; or
      </li>
      <li>
        our reasonable reliance on any information, instructions, notices or
        communications that we believe to be from you and/or a person authorised
        by you to give the same, including any person authorised to give
        instructions in respect of your Plan.
      </li>
    </ul>
    <p>
      We will take reasonable care in the assessment and appointment of
      sub-custodians, pension scheme administrators, bankers, counterparties,
      agents and other third parties. Subject to the performance of that duty we
      will not be liable for any losses, damages or costs suffered or incurred
      by you that is attributable to the performance of any third party involved
      in the provision of the Services.
    </p>
    <p>
      We will not be responsible for any liabilities arising because of any
      circumstance outside of its reasonable control. Such circumstances may
      include, but are not limited to, changes in applicable law, governmental,
      regulatory or judicial changes, currency restrictions, acts of God, civil
      unrest, war, terrorism, strikes, lock-outs, industrial disputes, breakdown
      in market systems or infrastructure (including of trading, clearing house,
      market participant or counterparty), failure, breakdown or disruption of
      electronic communications or other communications or computer service.
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Indemnity</strong></div>
    <p>
      You agree to indemnify and hold us, our related corporations, and our
      respective directors, officers, employees, agents and representatives,
      independent contractors, licensees, successors and assigns harmless from
      and against all claims, losses, expenses, damages and costs (including but
      not limited to direct, incidental, consequential, exemplary and indirect
      damages), and reasonable legal fees, resulting from or arising out of your
      act, default or omission, whether in your use of our Services, and/or any
      websites or software in relation thereto or otherwise, and whether in
      respect of your breach of these Terms or any laws or regulations or
      otherwise.&nbsp;
    </p>
  </div>
  <div class="legal__row">
    <div class="legal__row__head"><strong>Other Important Terms</strong></div>
    <p>
      We shall not be in breach of these Terms if there is, and shall not be
      liable or have responsibility of any kind for any loss or damage incurred
      by you as a result of, any total or partial failure, interruption or delay
      in performance of our duties and obligations occasioned by any act of God,
      fire, act of government, state, governmental or supranational body or
      regulatory authority or war, civil commotion, terrorism, failure of any
      computer dealing system, interruptions of power supplies, labour disputes
      of whatever nature or any other reason (whether or not similar in kind to
      any of the above) beyond our reasonable control.
    </p>
    <p>
      A person who is not a party to this Agreement will not have any benefits
      under this Agreement and will not have any rights to enforce its terms.
    </p>
    <p>
      These Terms are personal to you, and you may not transfer or assign any
      rights or obligations to any third party. We may assign or transfer its
      rights and obligations under the Agreement to any Affiliate or to any
      successor business. If this occurs, you will be notified by email. We will
      only transfer your money and/or assets to another person who we believe
      will hold them under applicable law or in respect of whom we have
      exercised all required due skill, care and diligence in assessing whether
      that person will apply adequate measures to protect it. If you object to
      such an assignment, you may terminate this Agreement and close your
      Account with us in accordance with these Terms.
    </p>
    <p>
      These Terms and any document expressly referred to in it constitutes the
      entire agreement between us regarding their subject matter, and supersedes
      and extinguishes all previous agreements, promises, assurances,
      warranties, representations and understandings between us, whether written
      or oral, relating to that subject matter. You agree that you shall have no
      remedies in respect of any statement, representation, assurance or
      warranty (whether made innocently or negligently) that is not set out in
      these Terms or any document expressly referred to in it. You agree that
      you shall have no claim for innocent or negligent misrepresentation or
      negligent misstatement based on any statement in these Terms or any
      document expressly referred to in it.
    </p>
    <p>
      If we fail to insist that you perform any of your obligations under these
      Terms, or if we do not enforce our rights against you, or if we delay in
      doing so, that will not mean that we have waived our rights against you
      and will not mean that you do not have to comply with those obligations.
      If we do waive a default by you, we will only do so in writing, and that
      will not mean that we will automatically waive any later default by
      you.&nbsp;
    </p>
    <p>
      Each of the conditions of these Terms operates separately. If any court or
      competent authority decides that any of them are unlawful or
      unenforceable, the remaining conditions will remain in full force and
      effect.&nbsp;
    </p>
    <p>
      These Terms, its subject matter and its formation, and any other disputes
      or claims in connection therewith, are governed by the law of Estonia. In
      the event of any such disputes or claims in connection with these Terms,
      you agree to first engage in good faith discussions with us to resolve
      such dispute or claim. If such dispute or claim is not resolved within
      sixty (60) days, we both irrevocably submit to the exclusive jurisdiction
      of the courts of Estonia.
    </p>
  </div>
</div>

<style>
  p {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 10px;
  }
</style>
